import {get_updates} from './updates'

// list of all middlewares
const list = {
  log_request(request, next) {
    // eslint-disable-next-line
    console.log(request);
    return next(request);
  },

  log_response(request, next) {
    const response = next(request);
    // eslint-disable-next-line
    console.log(response);
    return response;
  },
  
  updates_manager(request, next) {
    const response = next(request) || {};
    const request_counters = request.data.update_counters
    if (request_counters) {
      response._updates = get_updates(request_counters);
    }
    return response;
  },
}

const logs = [
  list.log_request,
  list.log_response,
]

const basic = [
  // ...logs,
  list.updates_manager,
]

export default {
  list,
  logs,
  basic,
}
